import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { MenuItem, Select, Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import NullCheck from "components/NullCheck";
import { Diversity2, GridViewOutlined, Toc, ManageSearchOutlined } from "@mui/icons-material";
import CustomButton from "components/CustomButton";
import CustomIconButton from "components/CustomIconButton";
import { useSelector } from "react-redux";

const Header = ({
  setSelectedArea,
  setSelectedMcStatus,
  selectedMcStatus,
  areas,
  mcStatus,
  setSelectedDevice,
  deviceList,
  selectedDevice,
  selectedArea,
  setTextSearch,
  textSearch,
  setOpenRelayGroup,
  displayType,
  onDisplayChange
}) => {
  const theme = useTheme()
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const biz = useSelector((state) => state?.biz?.data);
  const filterCount = 1 + (areas?.length > 1 ? 1 : 0) + (deviceList?.length > 1 ? 1 : 0);

  return (
    <Stack sx={{ width: '100%', minWidth: 0, display: 'grid', gap: 1,
      gridTemplateColumns: { xs: 'minmax(0, 1fr) auto', lg: 'minmax(0, 1fr) minmax(0, 1fr) auto' },
      gridTemplateAreas: { xs: '"filters filters" "search tools"', lg: '"filters search tools"' }, alignItems: 'center' }}>
      <Stack sx={{ gridArea: 'filters', display: 'grid', gap: 1, minWidth: 0,
        gridTemplateColumns: { xs: `repeat(${Math.min(filterCount, 2)}, minmax(0, 1fr))`, sm: `repeat(${filterCount}, minmax(0, 1fr))` } }}>
        <Select
          sx={{ width: '100%', minWidth: 0, bgcolor: "bg.main" }}
          size="small"
          MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
          value={selectedMcStatus}
          defaultValue={0}
          onChange={(e) => setSelectedMcStatus(e.target.value)}
        >
          {mcStatus?.map((st, index) => {
            return (
              <MenuItem key={index} value={st?.id}>
                <Typography>{bt(st?.title)}</Typography>
              </MenuItem>
            );
          })}
        </Select>

        <NullCheck valueForCheck={areas?.length > 1}>
          <Select
            sx={{ width: '100%', minWidth: 0, bgcolor: "bg.main" }}
            size="small"
            MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
            value={selectedArea}
            defaultValue={'all'}
            onChange={(e) => setSelectedArea(e.target.value)}
          >
            <MenuItem value={"all"}>
              <Typography>{bt("ALL_AREAS")}</Typography>
            </MenuItem>

            {areas?.map((area, index) => {
              return (
                <MenuItem key={index} value={area?.id}>
                  <Typography>{area?.name}</Typography>
                </MenuItem>
              );
            })}
          </Select>
        </NullCheck>

        <NullCheck valueForCheck={deviceList?.length > 1}>
          <Select
            sx={{ width: '100%', minWidth: 0, bgcolor: "bg.main", gridColumn: { xs: filterCount === 3 ? '1 / -1' : 'auto', sm: 'auto' } }}
            size="small"
            MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
            value={selectedDevice}
            defaultValue={'all'}
            onChange={(e) => setSelectedDevice(e.target.value)}
          >
            <MenuItem value={"all"}>
              <Typography>{bt("ALL_DEVICE")}</Typography>
            </MenuItem>

            {deviceList?.map((d, index) => {
              return (
                <MenuItem key={index} value={d}>
                  <Typography>{bt(d)}</Typography>
                </MenuItem>
              );
            })}
          </Select>
        </NullCheck>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ gridArea: 'search', minWidth: 0 }}>

        <TextField
          size="small"
          sx={{ flex: 1, width: '100%', minWidth: 0, borderRadius: 3, bgcolor: "bg.main" }}
          onChange={(e) => setTextSearch(e?.target?.value)}
          value={textSearch}
          placeholder={bt("SEARCH")}
          InputProps={{
            endAdornment: <ManageSearchOutlined
              sx={{ color: textSearch !== "" ? "primary.main" : "primary.text" }}
              fontSize="small"
            />
          }}
        />

        <NullCheck valueForCheck={biz?.hasMcCommandGroup}>
          {isMobile
            ? <CustomIconButton
              size="small"
              hideBgcolor
              icon={<Diversity2 />}
              onClick={() => setOpenRelayGroup(true)}
            />
            : <CustomButton
              title="GROUP_COMMAND"
              onClick={() => setOpenRelayGroup(true)}
            />
          }
        </NullCheck>
      </Stack>

    <ToggleButtonGroup value={displayType} exclusive size="small" aria-label={bt('DISPLAY_TYPE')}
      onChange={(event, value) => { if (value) onDisplayChange(value); }}
      sx={{ gridArea: 'tools', flexShrink: 0 }}>
      <Tooltip title={bt('CARDS')}><ToggleButton value="cards" aria-label={bt('CARDS')}><GridViewOutlined fontSize="small" /></ToggleButton></Tooltip>
      <Tooltip title={bt('TABLE')}><ToggleButton value="table" aria-label={bt('TABLE')}><Toc fontSize="small" /></ToggleButton></Tooltip>
    </ToggleButtonGroup>
    </Stack>
  );
};
export default Header;
